import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';
import { SvgLoaderComponent } from 'app/components/ui-kit/images/svg-loader/svg-loader.component';

@Component({
  selector: 'app-toggle-item-row',
  standalone: true,
  imports: [CommonModule, SvgLoaderComponent],
  templateUrl: './toggle-item-row.component.html',
  styleUrl: './toggle-item-row.component.scss'
})
export class ToggleItemRowComponent implements OnDestroy {
  @Input() value: string = '';
  @Input() iconURL: string | null = null;
  @Input() options: { value: string; label: string }[] = [];
  @Input() fullWidth = false;
  @Output() valueChange = new EventEmitter<string>();

  expanded = false;
  animate = false;
  private timer: any;

  constructor(private el: ElementRef<HTMLElement>) { }

  get current() {
    return this.options.find(o => o.value === this.value) || this.options[0];
  }

  toggle() {
    if (!this.expanded) {
      this.expanded = true;
      this.startTimer();
    } else {
      this.expanded = false;
      this.clearTimer();
    }
  }

  select(val: string) {
    this.value = val;
    this.valueChange.emit(this.value);
    this.closeWithAnimation();
  }

  getIconUrl(icon: string) {
    return icon.includes('/') ? icon : `assets/icons/${icon}`;
  }

  private closeWithAnimation() {
    this.expanded = false;
    this.clearTimer();
    this.animate = true;
    setTimeout(() => (this.animate = false), 300);
  }

  private startTimer() {
    this.clearTimer();
    this.timer = setTimeout(() => (this.expanded = false), 50000);
  }

  private clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  @HostListener('document:click', ['$event'])
  handleDocumentClick(event: Event) {
    if (this.expanded && !this.el.nativeElement.contains(event.target as Node)) {
      this.expanded = false;
      this.clearTimer();
    }
  }

  ngOnDestroy() {
    this.clearTimer();
  }
}
